import { Dialog, DialogContent, DialogContentText, DialogTitle, Grid, DialogActions, Button } from "@material-ui/core"
import { useDispatch, useSelector } from "react-redux";
import { TraerCotizaciones} from "../../../actions/compras/Cotizaciones";
import React from 'react';

export const ModalAvisoOferente = (props) => {
    const { datoNuevoDetalleCotizacion } = useSelector((state) => state.compras);
    const dispatch = useDispatch();

   /* const enviarMailAvisoIncorporacionOferente = () => {
        datoNuevoDetalleCotizacion &&
        datoNuevoDetalleCotizacion.foreach((item) => {
            if (item.esProveedor !== true) {
                dispatch(enviarMailIncorporacionOferente(props.idSolicitud, item.idOferente));
            }
        })
    }*/
    return (
        <Dialog
            fullWidth
            maxWidth={'sm'}
            open={props.open}
        >
            <React.Fragment>
                <Grid item container justify='center'>
                    <DialogTitle>
                        Aviso
                    </DialogTitle>
                    <DialogContent style={{ inlineSize: "-webkit-fill-available" }} >
                        <DialogContentText id="alert-dialog-slide-description">
                            {datoNuevoDetalleCotizacion &&
                                datoNuevoDetalleCotizacion.map((item) => {
                                    if (item.esProveedor !== true) {
                                        return (
                                            <span>El oferente {item.razonSocial} no se encuentra entre los contratos de proveedores de OSPEDYC.
                                                {<br />}</span>
                                        )
                                    }
                                    return null
                                })
                            }

                        </DialogContentText>
                        <DialogActions>
                            <Grid container style={{ padding: '25px' }}>
                                <Grid item xs={12}>
                                    <Grid
                                        container
                                        spacing={1}
                                        direction="row"
                                        justify="center"
                                        alignItems="center"
                                    >
                                        <Button
                                            color="primary"
                                            variant="contained"
                                            type='submit'
                                            style={{ marginLeft: '1rem' }}
                                            onClick={() => {
                                                dispatch(props.closeModalHandler);
                                                dispatch(TraerCotizaciones(props.idEstado))
                                            }}
                                        >
                                            Aceptar
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </DialogActions>
                    </DialogContent>
                </Grid>
            </React.Fragment>
        </Dialog>
    )
}